import _extends from '@babel/runtime/helpers/extends';
import React__default from 'react';
import styled, { useTheme } from 'styled-components';
import { g as getStarSVG } from './getStarSVG-CG9iR6qF.js';
import { C as ClassNamePassthrough } from '../LocalModules/storm-ui-utils/dist/esm/ClassNamePassthrough-BOut0eKj-BOut0eKj.js';

const StarRatingContainer = /*#__PURE__*/styled(ClassNamePassthrough).withConfig({
  componentId: "sc-storm-ui-40017521__sc-nmdrvs-0"
})(["/*! @noflip */ [dir=\"rtl\"] &&{/*! @noflip */ transform:scaleX(-1);}height:1em;vertical-align:-0.125em;pointer-events:none;"]);
const StarsContainer = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-storm-ui-40017521__sc-nmdrvs-1"
})(["display:", ";"], ({
  $inline
}) => $inline ? 'inline-flex' : 'inline');

/**
 * Builds a string of star SVGs to be inserted into the HTML
 */
const renderStars = (rating, className, borderColor, fillColor, emptyColor) => {
  const roundedRating = Math.round(rating * 2) / 2;
  let stars = '';
  for (let i = 1; i <= 5; i++) {
    if (roundedRating === 0) {
      stars += getStarSVG(false, false, className, borderColor, fillColor, emptyColor);
    } else if (i === roundedRating + 0.5) {
      stars += getStarSVG(true, false, className, borderColor, fillColor, emptyColor);
    } else if (i <= roundedRating) {
      stars += getStarSVG(true, true, className, borderColor, fillColor, emptyColor);
    } else {
      stars += getStarSVG(false, false, className, borderColor, fillColor, emptyColor);
    }
  }
  return {
    __html: stars
  };
};
const getValidRating = rating => {
  if (rating < 0) return 0;
  if (rating > 5) return 5;
  return rating;
};
const StarRating = ({
  rating = 0,
  ratingSuffix = 'out of 5 stars',
  starColor = 'amazonui',
  inline = false,
  'aria-label': ariaLabel,
  ...rest
}) => {
  const validRating = getValidRating(rating);
  const theme = /*#__PURE__*/useTheme();
  const {
    borderColor,
    fillColor,
    emptyColor: starEmpty
  } = theme.starRating;
  const starBorder = borderColor[starColor];
  const starFill = fillColor[starColor];
  return /*#__PURE__*/React__default.createElement(StarRatingContainer, null, className => /*#__PURE__*/React__default.createElement(StarsContainer, _extends({}, rest, {
    $inline: inline,
    role: "img",
    "aria-label": ariaLabel || `${validRating} ${ratingSuffix}`
    /** Dangerously setting innerHTML was found to be up to
     * 10x more performant than rendering as React elements
     * due to the amount of SVGs required in the StarRating component. */,
    dangerouslySetInnerHTML: renderStars(validRating, className !== null && className !== void 0 ? className : '', starBorder, starFill, starEmpty)
  })));
};

export { StarRating as S };
//# sourceMappingURL=StarRating-TPz42uJR.js.map
